import React, { useState } from "react";
import { FmHeaderSlider } from "..";
import Collapse from "@mui/material/Collapse";
import useStyles from "../FmCollapsible/FmCollapsible.style";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import IconButton, { IconButtonProps } from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";

interface ExpandMoreProps extends IconButtonProps {
    expand: boolean;
}

interface FmCollapsibleProps {
    renderTitle: any;
    children: any;
    stepNumber: number;
    expended: any;
    handleExpandClick: any;
}

const FmCollapsible = ({ renderTitle, children, stepNumber, expended, handleExpandClick }: FmCollapsibleProps): any => {
    const classes = useStyles();

    const ExpandMore = styled((props: ExpandMoreProps) => {
        const { expand, ...other } = props;
        return <IconButton {...other} />;
    })(({ theme, expand }) => ({
        transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
        marginLeft: "auto",
        transition: theme.transitions.create("transform", {
            duration: theme.transitions.duration.shortest,
        }),
    }));

    return (
        <>
            <div className={classes.collapsible_container}>
                <div className={classes.collapsible_box}>
                    {renderTitle}
                    <ExpandMore expand={expended} onClick={handleExpandClick} aria-expanded={expended}>
                        <ExpandMoreIcon />
                    </ExpandMore>
                </div>
            </div>
            <div className={classes.headerSlider}>
                <FmHeaderSlider stepNumber={stepNumber} />
                <Collapse in={expended} timeout={120} unmountOnExit className={classes.collapse_open}>
                    {children}
                </Collapse>
            </div>
        </>
    );
};

export default FmCollapsible;
